import {createReducer, on} from '@ngrx/store';
import {
  CadModelRevisionValidationMessage
} from "../../../shared/models/cad-model.model";
import {StateStatus} from "../../../shared/models/state-status.models";
import {createEntityAdapter, EntityState} from "@ngrx/entity";
import {
} from "../cad-model/cad-model.action";
import {
  loadCadModelRevisionValidationMessages, loadCadModelRevisionValidationMessagesFailure,
  loadCadModelRevisionValidationMessagesSuccess
} from "./cad-model-revision-message.action";


const cadModelRevisionMessageAdapter = createEntityAdapter<CadModelRevisionValidationMessage>()

export interface CadModelRevisionMessageState extends EntityState<CadModelRevisionValidationMessage>{
  selectedCadModelRevisionId: string;
  cadModelRevisionMessageStatus: StateStatus;
  error: any;
}

export const initialState: CadModelRevisionMessageState = {
    ...cadModelRevisionMessageAdapter.getInitialState({
      cadModelRevisionMessageStatus: 'pending',
      error: null,
      selectedCadModelRevisionId: ''
    }),
  };

export const cadModelRevisionMessageReducer = createReducer(
  initialState,
  on(loadCadModelRevisionValidationMessages, (state, { cadModelRevisionId}): CadModelRevisionMessageState =>
    ({
      ...state,
      selectedCadModelRevisionId: cadModelRevisionId,
      cadModelRevisionMessageStatus: 'loading' as StateStatus
    })),
  on(loadCadModelRevisionValidationMessagesSuccess, (state, { cadModelRevisionMessage }): CadModelRevisionMessageState => {
    return cadModelRevisionMessageAdapter.upsertOne({id: cadModelRevisionMessage.id, messages: cadModelRevisionMessage.messages}, {
      ...state,
      cadModelRevisionMessageStatus: 'loadSuccess' as StateStatus
    })
  }),
  on(loadCadModelRevisionValidationMessagesFailure, (state, { error }): CadModelRevisionMessageState => ({
    ...state,
    error: error,
    cadModelRevisionMessageStatus: 'error' as StateStatus,
  })),
);
